import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import CustomTooltip from "../../customComponents/customTooltip";
import moment from "moment";
import { isNullOrEmpty } from "../../utils";
import { FormatDate } from "../../utils/dateFormat";
import { ParseHtml } from "../../utils/parseHtml";
import {
  getAgentCoachHistoryById,
  getExecAgentdashboardCoachingDetails,
  getAgentCurrentCommitmentsByCoachingId,
  getAgentCurrentCommitmentsByCoachingIdReset,
} from "../../store/actions";
import { FormLoader } from "../../utils/Loader";
const CoachingDetailsModal = ({ clickedRow, showModal, toggleModal }) => {
  const dispatch = useDispatch();
  const [tooltipVisible, setTooltipVisible] = useState({});

  const {
    activeOrganizationInfo,
    coachHistoryByIdInfo,
    isFetching,
    currentCommitmentsByCoachingId,
  } = useSelector(
    ({
      get_active_organization_detail: { data: activeOrganizationData },

      get_exec_agent_dashboard_coaching_details: {
        data: coachHistoryByIdData,
        isFetching,
      },
      get_agent_current_commitments_by_coaching_id: {
        data: currentCommitmentsByCoachingIdData,
      },
    }) => {
      return {
        activeOrganizationInfo: activeOrganizationData || {},
        coachHistoryByIdInfo: coachHistoryByIdData,
        currentCommitmentsByCoachingId: currentCommitmentsByCoachingIdData,
        isFetching: isFetching,
      };
    },
    shallowEqual,
  );
  useEffect(() => {
    dispatch(
      getExecAgentdashboardCoachingDetails({
        companyguid: activeOrganizationInfo?.Companyguid,
        organization: activeOrganizationInfo?.Organization,
        employeeid: activeOrganizationInfo?.Employeeid,
        primaryprogram: activeOrganizationInfo?.Program,
        accessloginid: activeOrganizationInfo?.Loginid,
        coachingid: clickedRow?.ncoachingid || clickedRow?.coachingid,
        canacknowledgecoaching: clickedRow?.canacknowledgecoaching,
        metricname: clickedRow?.metricname,
        bublecolor: clickedRow?.bublecolor,
        attachments: clickedRow?.attachments,
        audiopath: null,
      }),
    );
    dispatch(
      getAgentCurrentCommitmentsByCoachingId({
        companyguid: activeOrganizationInfo?.Companyguid,
        organization: activeOrganizationInfo?.Organization,
        employeeid: activeOrganizationInfo?.Employeeid,
        program: activeOrganizationInfo?.Program,
        coachingid: clickedRow?.ncoachingid || clickedRow?.coachingid,
      }),
    );
  }, []);
  const handleTooltipHover = (id) => {
    setTooltipVisible((prevStatus) => ({
      ...prevStatus,
      [id]: !prevStatus[id],
    }));
  };
  const closeBtn = (
    <div className="links_right w-45">
      {coachHistoryByIdInfo &&
        !isNullOrEmpty(coachHistoryByIdInfo?.audiopath) && (
          <div className="coaching_audio">
            <audio
              controls
              controlsList="nodownload"
              style={{
                fontSize: "10px",
              }}
            >
              <source src={coachHistoryByIdInfo?.audiopath} type="audio/mp3" />
            </audio>
          </div>
        )}
      {/* {!isNullOrEmpty(coachHistoryByIdInfo?.attachments) && (
            <div className="coaching_file_doc">
              <img
                title="attached"
                src="images/file_upload.svg"
                style={{
                  cursor: "pointer",
                }}
                onClick={toggleDocModal}
              />
            </div>
          )} */}
      <button className="modal_close" onClick={toggleModal} type="button">
        <img src="/images/close.svg" />
      </button>
    </div>
  );
  const {
    bublecolor,
    mmcfConfigValues,
    getMMCFAgentCoachingHistoryV4,
    microLearningCoachingForm,
    ackConfigList,
    canacknowledgecoaching,
  } = coachHistoryByIdInfo || {};
  let isL1_Agent =
    activeOrganizationInfo?.titleroletype?.toLowerCase() == "l1" ||
    activeOrganizationInfo?.titleroletype?.toLowerCase() == "agent";

  const filterItems = (condition) => {
    return (
      getMMCFAgentCoachingHistoryV4?.filter((item) => {
        return condition(item);
      }) ?? []
    );
  };

  const filteredByActRichUrlMetric = filterItems((item) => {
    return (
      item.lableName !== "Ack" &&
      item.inputType !== "RichText" &&
      item.inputType !== "Url" &&
      item.lableType !== "MetricRichText" &&
      item.lableType !== "ProgramNotesPlainText"
    );
  });

  const filteredByMetric = filterItems((item) => {
    return item.lableType === "MetricRichText";
  });

  const filteredByUrl = filterItems((item) => {
    return item.inputType === "Url";
  });

  const filteredByRichTextMetric = filterItems((item) => {
    return (
      (item.inputType === "RichText" && item.lableType !== "MetricRichText") ||
      (item.InputType === "Text" && item.lableType === "ProgramNotesPlainText")
    );
  });

  const filteredByAck = filterItems((item) => {
    return item.lableName === "Ack" && item.lableValue != null;
  });
  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      //   className={className}
      backdrop={true}
      keyboard={true}
      id="coaching_history_modal"
      style={{
        maxWidth: "90%",
      }}
    >
      <ModalHeader
        toggle={toggleModal}
        close={closeBtn}
        className="custom-modal metric_header"
      >
        <div className="d-flex flex-start align-center">
          <div className="title">Coaching Details</div>
          <CustomTooltip
            tooltipText="?"
            tooltipDesc="View the details of the selected coaching session"
          />
        </div>
      </ModalHeader>
      <ModalBody id="">
        {isFetching ? (
          <div className="text-center">
            <FormLoader width={800} />
          </div>
        ) : (
          <div className="row">
            {/* AVG WRAP TIME */}
            {currentCommitmentsByCoachingId?.map((item, index) => {
              let percentPix =
                item.currentprogressinpercentage == 100 ? "-11px" : "-1px";
              const hasDisplayName = !isNullOrEmpty(item.metricDisplayName);
              const isPastCommit =
                item.commitdate &&
                moment()
                  .startOf("day")
                  .isAfter(moment(item.commitdate).startOf("day"));

              const actualValue = isPastCommit
                ? item.actualonfollowupdateValue
                : item.currentactual;

              const displayDate = isPastCommit
                ? item.commitdate
                : item.currentactualdate;
              return (
                <div className="col-md-12" key={item.metricname + index}>
                  <div className="commitmenet_status">
                    <div className="coach_metricname">
                      <div
                        className={hasDisplayName ? "CustomtextTransform" : ""}
                      >
                        {hasDisplayName
                          ? item.metricDisplayName
                          : item.metricname}
                      </div>
                    </div>
                    <div className="commitment_progress">
                      <div className="d-flex space-between align-center pb-7">
                        <div className="commit_actual mr-3">
                          {item.actualoncoacheddate}
                        </div>
                        {/* commitment flow */}
                        <div class="w-100 position-relative">
                          <div
                            className="commit_actual_today"
                            style={{
                              left: `${item.currentprogressinpercentage}%`,
                            }}
                          >
                            {isPastCommit
                              ? item.actualonfollowupdateValue
                              : item.currentactual}
                          </div>
                          <div className="commitment_flow position-relative">
                            <div className="start-date-bubble">
                              <div
                                className="tool"
                                onMouseEnter={() =>
                                  handleTooltipHover(`${item.ncoachingid}1`)
                                }
                                onMouseLeave={() =>
                                  handleTooltipHover(`${item.ncoachingid}1`)
                                }
                              >
                                <div
                                  className={`commit-tooltip ${
                                    tooltipVisible[`${item.ncoachingid}1`] &&
                                    "block"
                                  }`}
                                  style={{
                                    zIndex: "2",
                                  }}
                                >
                                  <ul>
                                    <li>
                                      <div className="d-flex space-between align-center">
                                        <div>ID</div>
                                        <div className="val">
                                          <b> {item.ncoachingid}</b>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex space-between align-center">
                                        <div>Date</div>
                                        <div className="val">
                                          {FormatDate(item.coacheddate)}
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex space-between align-center">
                                        <div>Coach</div>
                                        <div className="val">
                                          <b> {item.coachedby}</b>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div
                              className="active_period_line"
                              style={{
                                width: `${item.currentprogressinpercentage}%`,
                              }}
                            ></div>
                            <div
                              className="current_bubble"
                              style={{
                                left: `${item.currentprogressinpercentage}%`,
                                marginLeft: percentPix,
                                backgroundColor: item.bublecolor
                                  ? item.bublecolor
                                  : "gray",
                              }}
                            >
                              <div
                                className="tool"
                                onMouseEnter={() =>
                                  handleTooltipHover(`${item.ncoachingid}2`)
                                }
                                onMouseLeave={() =>
                                  handleTooltipHover(`${item.ncoachingid}2`)
                                }
                              >
                                <div
                                  className={`commit-tooltip ${
                                    tooltipVisible[`${item.ncoachingid}2`] &&
                                    "block"
                                  }`}
                                  style={{
                                    right: "0px",
                                  }}
                                >
                                  <ul>
                                    <li>
                                      <div className="d-flex space-between align-center">
                                        <div>Actual</div>
                                        <div className="val">
                                          <b>{actualValue}</b>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex space-between align-center">
                                        <div>Date</div>
                                        <div className="val">
                                          {FormatDate(displayDate)}
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="end_date_bubble">
                              <div
                                className="tool"
                                onMouseEnter={() =>
                                  handleTooltipHover(`${item.ncoachingid}3`)
                                }
                                onMouseLeave={() =>
                                  handleTooltipHover(`${item.ncoachingid}3`)
                                }
                              >
                                <div
                                  className={`commit-tooltip ${
                                    tooltipVisible[`${item.ncoachingid}3`] &&
                                    "block"
                                  }`}
                                >
                                  <ul>
                                    <li>
                                      <div className="d-flex space-between align-center">
                                        <div>Committment</div>
                                        <div className="val">
                                          <b>{item.commitment}</b>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div
                                        className="d-flex space-between align-center"
                                        style={{
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        <div>Follow Up Date</div>
                                        <div className="val">
                                          {FormatDate(item.commitdate)}
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="commit_dates d-flex space-between align-center">
                            <div className="commit_start_date">
                              <b>{FormatDate(item.coacheddate)}</b>
                            </div>
                            <div className="commit_end_date">
                              <b>{FormatDate(item.commitdate)}</b>
                            </div>
                          </div>
                        </div>
                        <div className="commit_actual ml-3">
                          {item.commitment}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {bublecolor?.toLowerCase() == "red" && (
              <div className="col-md-12">
                <div className="trending_below_commitment d-flex space-between align-center">
                  <div className="d-flex flex-start align-center">
                    <div className="trending">
                      <img src="/images/icon_outline.svg" />
                    </div>
                    <div className="red"> Trending to miss Commitment</div>
                    <div className="review_text">Review Coaching Details</div>
                  </div>
                </div>
              </div>
            )}
            {bublecolor?.toLowerCase() == "green" && (
              <div className="col-md-12">
                <div class="coaching_above_trending_block">
                  <div className="alert-above-commit metdet">
                    <div className="div-block-1097">
                      <div className="div-block-1098">
                        <img src="/images/checkmark.svg" />
                      </div>
                      <div>
                        <strong>Trending to meet or exceed commitment</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {getMMCFAgentCoachingHistoryV4?.length > 0 && (
              <>
                <div className="coached_fields">
                  <div className="d-flex flex-start align-start">
                    {filteredByActRichUrlMetric?.map((item) => {
                      return isL1_Agent ? (
                        item.showdetailsonagentlevel === true && (
                          <div className="form-group">
                            <label className="lbl">{item.lableName}</label>
                            {item.InputType?.toLowerCase() === "date" &&
                            item.lableType !== "Ack date" ? (
                              <div className="form-control">
                                {FormatDate(item.lableValue)}
                              </div>
                            ) : (
                              <div className="form-control">
                                {ParseHtml(item.lableValue)}
                              </div>
                            )}
                          </div>
                        )
                      ) : (
                        <div className="form-group">
                          <label className="lbl">{item.lableName}</label>
                          {item.InputType?.toLowerCase() === "date" &&
                          item.lableType !== "Ack date" ? (
                            <div className="form-control">
                              {FormatDate(item.lableValue)}
                            </div>
                          ) : (
                            <div className="form-control">
                              {ParseHtml(item.lableValue)}
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {filteredByMetric?.map((item) => {
                      return isL1_Agent ? (
                        item.showdetailsonagentlevel === true && (
                          <div className="form-group">
                            <label className="lbl">{item.lableName}</label>
                            <div className="form-control">
                              {ParseHtml(item.lableValue)}
                            </div>
                          </div>
                        )
                      ) : (
                        <div className="form-group">
                          <label className="lbl">{item.lableName}</label>
                          <div className="form-control">
                            {ParseHtml(item.lableValue)}
                          </div>
                        </div>
                      );
                    })}
                    {filteredByUrl?.map((item) => {
                      return isL1_Agent ? (
                        item.showdetailsonagentlevel === true && (
                          <div className="form-group">
                            <label className="lbl">{item.lableName}</label>
                            <div className="form-control">
                              <a href={item.lableValue} target="_blank">
                                {ParseHtml(item.lableValue)}
                              </a>
                            </div>
                          </div>
                        )
                      ) : (
                        <div className="form-group">
                          <label className="lbl">{item.lableName}</label>
                          <div className="form-control">
                            <a href={item.lableValue} target="_blank">
                              {ParseHtml(item.lableValue)}
                            </a>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="reviews_learning">
                  <h6>Reviewed Learning</h6>
                  <div>
                    {microLearningCoachingForm?.map((item, index) => {
                      return (
                        <b key={index}>
                          <a href={item.videopath} target="_blank">
                            {item.skillname}
                          </a>
                        </b>
                      );
                    })}
                  </div>
                </div>
                <div className="notes">
                  <h3>Notes</h3>
                </div>
                <div className="notes_fields">
                  {filteredByRichTextMetric?.map((item) => {
                    return isL1_Agent ? (
                      item.showdetailsonagentlevel === true && (
                        <div className="form-group">
                          <label className="lbl">{item.lableName}</label>
                          {item.lableValue && (
                            <div className="form-control">
                              <div
                                style={{
                                  backgroundColor: "#f8f8f8",
                                  borderColor: "##cdcdcd",
                                }}
                              >
                                {ParseHtml(item.lableValue)}
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    ) : (
                      <div className="form-group">
                        <label className="lbl">{item.lableName}</label>
                        {item.lableValue && (
                          <div className="form-control">
                            <div
                              style={{
                                backgroundColor: "#f8f8f8",
                                borderColor: "##cdcdcd",
                              }}
                            >
                              {ParseHtml(item.lableValue)}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                {filteredByAck?.length > 0 && (
                  <div className="afni_check">
                    <div className="col-md-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="afni_radiobtn"
                          checked
                          disabled
                        />
                        <label className="form-check-label" for="afni_radiobtn">
                          {ackConfigList?.map(
                            (item) => item.configurationValue,
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};
export default CoachingDetailsModal;
